import { createFileRoute } from '@tanstack/react-router';
import { RoleModule } from '@/modules/role';

export const Route = createFileRoute('/(dashboard)/_dashboard/hr/role/')({
  component: RoleModule,
});
